import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { faSearch, faPencilAlt, faCheck, faTimes, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt, faCalendarCheck, faHandshake, faTimesCircle, faCheckCircle, faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../shared/services/admin-services/user.service';
import { RecommendationService } from '../shared/services/recommendation.service';
import { Observable, Subscription } from 'rxjs';
import { Recommendation } from '../shared/models/recommendation.model';
import { Filter } from '../shared/models/filter.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { WorkStatusService } from '../shared/services/admin-services/work-status.service';
import { IncomeService } from '../shared/services/admin-services/income.service';
import { Lookup } from '../shared/models/admin-models/lookup.model';
import { Appointment } from '../shared/models/appointment.model';
import { AppointmentService } from '../shared/services/appointments.service';
import { AppointmentStatusService } from '../shared/services/admin-services/appointment-status.service';
import { RoleSendService } from '../shared/services/role-send.service';
import { SendSNOService } from '../shared/services/sno.service';

@Component({
  selector: 'app-recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.sass']
})
export class RecommendationsComponent implements OnInit, OnDestroy {
  faCalendarAlt = faCalendarAlt;
  faSearch = faSearch;
  faPencilAlt = faPencilAlt;
  faCalendarCheck = faCalendarCheck;
  faHandshake = faHandshake;
  faCheck = faCheck;
  faTimes = faTimes;
  faFileDownload = faFileDownload;
  faTimesCircle = faTimesCircle;
  faCheckCircle = faCheckCircle;
  faPaperPlane = faPaperPlane

  @ViewChild('alertModal', { static: false }) private alertModal;
  errorTitle;
  @ViewChild('succesModal', { static: false }) private succesModal;
  successTitle: String = "";

  recommendationArray;
  workStatusArray: Observable<Lookup[]>;
  incomeArray: Observable<Lookup[]>;
  policyStatusArray: Observable<Lookup[]>;
  appointmentStatusArray: Observable<Lookup[]>;
  usersBox: Observable<{ id: Number, display: String }[]>

  userId: Number;
  recommendationId: Number;
  addOrEditBool: Boolean = true;

  dateMinimum: { year: Number, month: Number, day: Number } = { year: 0, month: 0, day: 0 };
  dateToday = new Date();
  filterDate = new Date();

  roleService: Subscription;
  roleType: String = '';

  total: Number
  filter: Filter = new Filter({ Top: 10, Page: 1, Filter: {}, Sort: {} })

  recommendationForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    street: new FormControl('', [Validators.required]),
    homeNumber: new FormControl('', [Validators.required]),
    settlement: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    phoneNumber: new FormControl('', [Validators.required]),
    mobile: new FormControl('', [Validators.required]),
    workStatus: new FormControl('', [Validators.required]),
    income: new FormControl('', [Validators.required]),
    remark: new FormControl('', [Validators.required]),
    agreement: new FormControl('', [Validators.required]),
  })

  appointmentsForm = new FormGroup({
    dateOfAppointment: new FormControl({ year: this.dateToday.getFullYear(), month: this.dateToday.getMonth(), day: this.dateToday.getDate() }, [Validators.required]),
    timeOfAppointment: new FormControl({ hour: 16, minute: 0 }, [Validators.required]),
    comment: new FormControl('', [Validators.required]),
    status: new FormControl('', [Validators.required]),
    visible: new FormControl(true, [])
  })


  hideOrShowBool: Boolean = false;
  filterForm = new FormGroup({
    dateFrom: new FormControl(null),
    dateTo: new FormControl(null),
    firstname: new FormControl(''),
    lastname: new FormControl(''),
    address: new FormControl(''),
    agentId: new FormControl(''),
    settlement: new FormControl(''),
    phoneNumber: new FormControl(''),
    email: new FormControl(''),
    contactType: new FormControl('')
  })

  constructor(private modalService: NgbModal, private userService: UserService, private recommendationService: RecommendationService, private workStatusSerivce: WorkStatusService, private incomeService: IncomeService, private appointmentsService: AppointmentService, private appointmentStatusService: AppointmentStatusService, private roleSendService: RoleSendService, private sendSNOService: SendSNOService) {
    this.roleService = this.roleSendService.info$.subscribe(
      (res: String) => {
        this.roleType = res;
      }
    )
  }

  ngOnInit() {
    // this.dateMinimum.year = this.dateToday.getFullYear()
    // this.dateMinimum.month = this.dateToday.getMonth();
    // this.dateToday.setDate(this.dateToday.getDate() - 3);
    // this.dateMinimum.day = this.dateToday.getDate();

    // this.dateToday.setDate(this.dateToday.getDate() + 3);

    // this.filterDate.setMonth(this.filterDate.getMonth() + 1);
    // this.filterForm.get('dateFrom').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })
    // this.filterForm.get('dateTo').setValue({ year: this.filterDate.getMonth() == 0 ? this.filterDate.getFullYear() - 1 : this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 0 ? 12 : this.filterDate.getMonth(), day: this.filterDate.getDate() })

    this.filterForm.get('dateFrom').setValue({ year: this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 11 ? 12 : this.filterDate.getMonth() + 1, day: this.filterDate.getDate() })
    this.filterForm.get('dateTo').setValue({ year: this.filterDate.getFullYear(), month: this.filterDate.getMonth() == 11 ? 12 : this.filterDate.getMonth() + 1, day: this.filterDate.getDate() })

    this.getAll();
    this.getUser();
    this.getWorkStatus();
    this.getIncome();
    this.getAppointmentStatus();
    this.getBoxViewUsers();
  }

  ngOnDestroy() {
    this.roleService.unsubscribe();
  }

  getAll() {
    this.filter.data.Filter = { AppointmentDateFrom: this.filterForm.value.dateFrom.year + '-' + this.filterForm.value.dateFrom.month + '-' + this.filterForm.value.dateFrom.day + " 00:00:00", AppointmentDateTo: this.filterForm.value.dateTo.year + '-' + this.filterForm.value.dateTo.month + '-' + this.filterForm.value.dateTo.day + " 23:59:00" };
    if (this.filterForm.value.firstname)
      this.filter.data.Filter.Firstname = this.filterForm.value.firstname
    if (this.filterForm.value.lastname)
      this.filter.data.Filter.Lastname = this.filterForm.value.lastname
    if (this.filterForm.value.address)
      this.filter.data.Filter.Address = this.filterForm.value.address
    if (this.filterForm.value.settlement)
      this.filter.data.Filter.Settlement = this.filterForm.value.settlement
    if (this.filterForm.value.phoneNumber)
      this.filter.data.Filter.PhoneNumber = this.filterForm.value.phoneNumber
    if (this.filterForm.value.email)
      this.filter.data.Filter.Email = this.filterForm.value.email
    if (this.filterForm.value.agentId)
      this.filter.data.Filter.UserID = this.filterForm.value.agentId

    if (this.filterForm.value.contactType == '0')
      this.filter.data.Filter.IsRecommendation = true
    if (this.filterForm.value.contactType == '1')
      this.filter.data.Filter.IsPersonalContact = true
    if (this.filterForm.value.contactType == '2') {
      this.filter.data.Filter.IsPersonalContact = true
      this.filter.data.Filter.IsRecommendation = true
    }

    // this.recommendationArray = this.recommendationService.gridView(this.filter)
    this.recommendationService.gridView(this.filter)
      .subscribe(
        (x: { data: [], total: Number }) => {
          console.log(x)
          this.recommendationArray = x.data
          this.total = x.total;
        }
      )
  }

  openAddModal(modal) {
    this.addOrEditBool = true;
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
  }
  addRecommendation() {
    let mobileRegex = new RegExp('0[0-9]{7,9}')
    if (!mobileRegex.test(this.recommendationForm.value.mobile)) {
      this.errorTitle = "Nije dobar broj mobilnog telefona";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      let recommendation = new Recommendation({
        Firstname: this.recommendationForm.value.firstname,
        Lastname: this.recommendationForm.value.lastname,
        Street: this.recommendationForm.value.street,
        HomeNumber: this.recommendationForm.value.homeNumber,
        Settlement: this.recommendationForm.value.settlement,
        PostalCode: this.recommendationForm.value.postalCode,
        Email: this.recommendationForm.value.email,
        PhoneNumber: this.recommendationForm.value.phoneNumber,
        Mobile: this.recommendationForm.value.mobile,
        WorkStatusID: parseInt(this.recommendationForm.value.workStatus),
        IncomeID: parseInt(this.recommendationForm.value.income),
        UserID: this.userId,
        Remark: this.recommendationForm.value.remark,
        PersonalAgreement: ""
      })
      console.log(recommendation);
      this.recommendationService.createContact(recommendation)
        .then(
          x => {
            console.log(x);
            this.getAll();
            this.modalService.dismissAll();
          }
        )
    }
  }

  openCreateAppoitntment(modal, id) {
    this.recommendationId = id
    this.appointmentsForm.reset({ timeOfAppointment: { hour: 16, minute: 0 }, dateOfAppointment: { year: this.dateToday.getFullYear(), month: this.dateToday.getMonth() + 1, day: this.dateToday.getDate() }, visible: true });
    this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
  }
  addAppointment() {
    let appointment = new Appointment({ TimeScheduled: this.appointmentsForm.value.dateOfAppointment.year + '-' + this.appointmentsForm.value.dateOfAppointment.month + '-' + this.appointmentsForm.value.dateOfAppointment.day + ' ' + this.appointmentsForm.value.timeOfAppointment.hour + ':' + this.appointmentsForm.value.timeOfAppointment.minute + ':00', AppointmentSource: 1, AppointmentStatus: parseInt(this.appointmentsForm.value.status), PhonebookID: 0, CallcenterAgent: "", UserID: this.userId, Latitude: 0, Longitude: 0, Comment: this.appointmentsForm.value.comment, ContactID: this.recommendationId })
    if (this.appointmentsForm.value.visible) {
      appointment.data.Visible = true
    } else {
      appointment.data.Visible = false
    }
    this.appointmentsService.createAppointment(appointment)
      .then(
        x => {
          console.log(x)
          this.getAll();
          this.modalService.dismissAll()
        }
      )

  }

  appointmentId: Number;
  phonebookId: Number;
  personalAgreements: String;
  uplaodToken: String
  uploadTokenExpires: String
  cccClientId: Number
  openEditModal(modal, id) {
    this.addOrEditBool = false;
    this.recommendationId = id;
    this.recommendationService.getOne(id)
      .then(
        (x: any) => {
          console.log(x);
          if (x.appointmentID) {
            this.appointmentId = x.appointmentID;
          } else {
            this.appointmentId = null
          }
          if (x.phonebookID) {
            this.phonebookId = x.phonebookID;
          } else {
            this.phonebookId = null
          }
          if (x.personalAgreement) {
            this.personalAgreements = x.personalAgreement;
          } else {
            this.personalAgreements = ''
          }

          this.uplaodToken = x.uplaodToken
          this.uploadTokenExpires = x.uploadTokenExpires
          this.cccClientId = x.ccClientID

          this.recommendationForm.get('firstname').setValue(x.firstname)
          this.recommendationForm.get('lastname').setValue(x.lastname)
          this.recommendationForm.get('street').setValue(x.street)
          this.recommendationForm.get('email').setValue(x.email)
          this.recommendationForm.get('homeNumber').setValue(x.homeNumber)
          this.recommendationForm.get('settlement').setValue(x.settlement)
          this.recommendationForm.get('postalCode').setValue(x.postalCode ? x.postalCode : '')
          this.recommendationForm.get('phoneNumber').setValue(x.phoneNumber ? x.phoneNumber : '')
          this.recommendationForm.get('mobile').setValue(x.mobile)
          this.recommendationForm.get('workStatus').setValue(x.workStatusID ? x.workStatusID : '')
          this.recommendationForm.get('income').setValue(x.incomeID ? x.incomeID : '')
          this.recommendationForm.get('remark').setValue(x.remark ? x.remark : '')
          this.modalService.open(modal, { backdrop: 'static', size: 'lg' })
        }
      )
  }
  editReccomendation() {
    let mobileRegex = new RegExp('0[0-9]{7,9}')
    if (!mobileRegex.test(this.recommendationForm.value.mobile)) {
      this.errorTitle = "Nije dobar broj mobilnog telefona";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      let recommendation = new Recommendation({
        ID: this.recommendationId,
        Firstname: this.recommendationForm.value.firstname ? this.recommendationForm.value.firstname.toUpperCase() : '',
        Lastname: this.recommendationForm.value.lastname ? this.recommendationForm.value.lastname.toUpperCase() : '',
        Street: this.recommendationForm.value.street ? this.recommendationForm.value.street.toUpperCase() : '',
        HomeNumber: this.recommendationForm.value.homeNumber,
        Settlement: this.recommendationForm.value.settlement ? this.recommendationForm.value.settlement.toUpperCase() : '',
        PostalCode: this.recommendationForm.value.postalCode,
        Email: this.recommendationForm.value.email,
        PhoneNumber: this.recommendationForm.value.phoneNumber,
        Mobile: this.recommendationForm.value.mobile,
        WorkStatusID: parseInt(this.recommendationForm.value.workStatus),
        IncomeID: parseInt(this.recommendationForm.value.income),
        UserID: this.userId,
        Remark: this.recommendationForm.value.remark,
        PersonalAgreement: this.personalAgreements,
        AppointmentID: this.appointmentId,
        PhonebookID: this.phonebookId,
        CCClientID: this.cccClientId,
        UploadToken: this.uplaodToken,
        UploadTokenExpires: this.uploadTokenExpires
      })
      console.log(recommendation);
      this.recommendationService.editContact(recommendation)
        .then(
          x => {
            console.log(x);
            this.getAll();
            this.modalService.dismissAll();
          }
        )
    }
  }


  onFileChanged(event, id) {
    console.log(event.target.files)
    const formData = new FormData();
    formData.append('ContactID', id);
    formData.append('File', event.target.files[0])
    this.recommendationService.getOne(id)
      .then(
        (x: { uploadToken: string }) => {
          console.log(x);
          formData.append('Token', x.uploadToken)
          this.recommendationService.uploadAgreement(formData)
            .subscribe(
              x => {
                console.log(x)
                this.getAll();
                this.modalService.dismissAll()
              },
              (e: { error: String }) => {
                console.log(e)
                this.errorTitle = e.error;
                this.modalService.open(this.alertModal, { centered: true })
              }
            )
        }
      )

  }

  downloadAgree(id) {
    // console.log(id)
    this.recommendationService.downloadAgreement(id)
      .then(
        (x: any) => {
          let blob = new Blob([x.body], { type: 'application/octet-stream' });
          var contentDispositionHeader = x.headers.get('Content-Disposition');
          console.log(contentDispositionHeader);
          var filename = contentDispositionHeader.split(';')[1].trim().split('=')[1];
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      )
  }

  sendHealth(mobile: String, email: String) {
    if (email != '' && mobile == '') {
      this.sendSNOService.sendSNOPZO({ Email: email, Mobile: '', SendDestination: 0 })
        .then(
          x => {
            this.modalService.dismissAll()
            this.successTitle = "Uspešno ste poslali link";
            this.modalService.open(this.succesModal, { centered: true })
          },
          e => {
            this.errorTitle = e.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    } else if (email == '' && mobile != '') {
      this.sendSNOService.sendSNOPZO({ Email: '', Mobile: mobile, SendDestination: 1 })
        .then(
          x => {
            this.modalService.dismissAll()
            this.successTitle = "Uspešno ste poslali link";
            this.modalService.open(this.succesModal, { centered: true })
          },
          e => {
            this.errorTitle = e.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    } else if (email != '' && mobile != '') {
      this.sendSNOService.sendSNOPZO({ Email: email, Mobile: '', SendDestination: 0 })
        .then(
          x => {
            this.sendSNOService.sendSNOPZO({ Email: '', Mobile: mobile, SendDestination: 1 })
              .then(
                x => {
                  this.modalService.dismissAll()
                  this.successTitle = "Uspešno ste poslali link";
                  this.modalService.open(this.succesModal, { centered: true })
                },
                e => {
                  this.errorTitle = e.error;
                  this.modalService.open(this.alertModal, { centered: true })
                }
              )
          },
          e => {
            this.errorTitle = e.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    }
  }

  sendKomDom(mobile: String, email: String) {
    if (email != '' && mobile == '') {
      this.sendSNOService.sendSNOKomDom({ Email: email, Mobile: '', SendDestination: 0 })
        .then(
          x => {
            this.modalService.dismissAll()
            this.successTitle = "Uspešno ste poslali link";
            this.modalService.open(this.succesModal, { centered: true })
          },
          e => {
            this.errorTitle = e.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    } else if (email == '' && mobile != '') {
      this.sendSNOService.sendSNOKomDom({ Email: '', Mobile: mobile, SendDestination: 1 })
        .then(
          x => {
            this.modalService.dismissAll()
            this.successTitle = "Uspešno ste poslali link";
            this.modalService.open(this.succesModal, { centered: true })
          },
          e => {
            this.errorTitle = e.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    } else if (email != '' && mobile != '') {
      this.sendSNOService.sendSNOKomDom({ Email: email, Mobile: '', SendDestination: 0 })
        .then(
          x => {
            this.sendSNOService.sendSNOKomDom({ Email: '', Mobile: mobile, SendDestination: 1 })
              .then(
                x => {
                  this.modalService.dismissAll()
                  this.successTitle = "Uspešno ste poslali link";
                  this.modalService.open(this.succesModal, { centered: true })
                },
                e => {
                  this.errorTitle = e.error;
                  this.modalService.open(this.alertModal, { centered: true })
                }
              )
          },
          e => {
            this.errorTitle = e.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    }
  }

  getUser() {
    this.userService.getUser()
      .then(
        (x: { id: Number }) => {
          this.userId = x.id;
        }
      )
  }

  getAppointmentStatus() {
    this.appointmentStatusArray = this.appointmentStatusService.gridView()
  }
  getWorkStatus() {
    this.workStatusArray = this.workStatusSerivce.gridView()
  }
  getIncome() {
    this.incomeArray = this.incomeService.gridView();
  }
  getBoxViewUsers() {
    this.usersBox = this.userService.boxView(new Filter({ Page: null, Top: null, Filter: {}, Sort: { SortBy: 'Active', Direction: 1 } }))
  }

  hideOrShow() {
    this.hideOrShowBool = !this.hideOrShowBool;
  }

  clearFilters() {
    this.filterForm.reset({ dateFrom: { year: this.filterForm.value.dateFrom.year, month: this.filterForm.value.dateFrom.month, day: this.filterForm.value.dateFrom.day }, dateTo: { year: this.filterForm.value.dateTo.year, month: this.filterForm.value.dateTo.month, day: this.filterForm.value.dateTo.day }, firstname: '', lastname: '', address: '', agentId: '', settlement: '', phoneNumber: '', email: '', contactType: '' });
    this.getAll();
  }

}
